module.exports = __webpack_public_path__ + "static/media/brain.d3c10622.ogg";